// extracted by mini-css-extract-plugin
export default {"heading":"LandscapeAboutContactPersonEditTemplate_heading__vGTSz","buttonLink":"LandscapeAboutContactPersonEditTemplate_buttonLink__Fy0U7"};